import './TapBar.css';
import React, {useContext, useEffect, useState} from 'react';
import MenuIcon from './images/menu_black.svg';
import MenuIconActive from './images/menu_violet.svg';
import CatalogIcon from './images/catalog_black.svg';
import CatalogIconActive from './images/catalog_violet.svg';
import BasketIcon from './images/basket_black.svg';
import BasketIconActive from './images/basket_blue.svg';
import ConnectIcon from './images/connect_black.svg';
import ConnectIconActive from './images/connect_violet.svg';
import PersonalIcon from './images/personal_black.svg';
import PersonalIconActive from './images/personal_violet.svg';
import MobileMenu from './mobileMenu/MobileMenu';
import MobileCatalog from './mobileCatalog/MobileCatalog';
import MobileNav from './mobileNav/MobileNav';
import MobilePersonal from './mobilePersonal/MobilePersonal';
import MobileCitySwitch from './mobileCitySwitch/MobileCitySwitch';
import {apiBaseUrl, axiosConfig, axiosInstance, eventEmitter, lang} from '../../common/baseData';
import {
  BasketContext,
  ClientWidthContext,
} from '../Context/ApplicationContextProvider';
import NovaPoshta from "../../api/novaposhta/NovaPoshta";

function TapBar(props) {
  const basket = useContext(BasketContext);
  const clientWidth = useContext(ClientWidthContext);

  const [state, setState] = useState({
    menu: [],
    catalog: [],
    popLink: [],
    popSec: [],
    personal: [],
    siteSwitch: [],
    citySwitch: {},
    messages: {},
    isAuth: false,
  });

  const [show, setShow] = useState(clientWidth < 1280);
  const [showCitySwitch, setShowCitySwitch] = useState(false);
  const [popBlock, setPopBlock] = useState(null);
  const [connectActive, setConnectActive] = useState(false);

  const menuTypes = [
    {
      icon: MenuIcon,
      activeIcon: MenuIconActive,
      type: 'menu',
    },
    {
      icon: CatalogIcon,
      activeIcon: CatalogIconActive,
      type: 'catalog',
    },
    {
      icon: BasketIcon,
      activeIcon: BasketIconActive,
      type: 'basket',
    },
    {
      icon: PersonalIcon,
      activeIcon: PersonalIconActive,
      type: 'personal',
    },
    {
      icon: ConnectIcon,
      activeIcon: ConnectIconActive,
      type: 'connect',
    },
  ];
  const [activeMenuType, setActiveMenuType] = useState(null);
  const [menuOpened, setMenuOpened] = useState(false);
  const [activeCatalogSection, setActiveCatalogSection] = useState(null);

  const [stateCities, setStateCities] = useState({
    cities: window.usedCityData &&
    window.usedCityData.hasOwnProperty('cityList') &&
    Array.isArray(window.usedCityData.cityList)
      ? window.usedCityData.cityList
      : [],
    deliveryCity: props.deliveryCity && typeof props.deliveryCity === 'object' ?
      props.deliveryCity : null,
  });

  const [currentCityId, setCurrentCityId] = useState(null);


  const npApi = new NovaPoshta(lang, axiosConfig);

  const [basketProductsCount, setBasketProductsCount] = useState(Array.isArray(basket.products) && basket.products.length ? basket.products.length : 0);
  const [heavyLoaded, setHeavyLoaded] = useState(false);

  useEffect(() => {
    setBasketProductsCount(Array.isArray(basket.products) && basket.products.length ? basket.products.length : 0)
  }, [basket])

  // init base state
  useEffect(() => {
    try {
      let baseData = JSON.parse(window.mobileMenuInitialState);
      setState({
        menu: baseData.menu || [],
        catalog: Array.isArray(baseData.catalog) ? baseData.catalog : [],
        popLink: Array.isArray(baseData.popLink) ? baseData.popLink : [],
        popSec: Array.isArray(baseData.popSec) ? baseData.popSec : [],
        personal: baseData.personal || [],
        siteSwitch: baseData.siteSwitch || [],
        citySwitch: baseData.citySwitch || {},
        messages: baseData.messages || {},
        isAuth: baseData.isAuth,
      });
      const inlineHasHeavy = Array.isArray(baseData.catalog) && baseData.catalog.length > 0;
      setHeavyLoaded(inlineHasHeavy);
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    const shouldLoadHeavy = menuOpened && !heavyLoaded;
    if (!shouldLoadHeavy) return;

    const url = typeof window.mobileMenuHeavyDataUrl === 'string' && window.mobileMenuHeavyDataUrl.length
      ? window.mobileMenuHeavyDataUrl
      : '/local/components/webhome/mobile.menu/heavy.ajax.php';

    if (!window.mobileMenuHeavyDataPromise) {
      window.mobileMenuHeavyDataPromise = fetch(url, {credentials: 'same-origin'})
        .then(response => {
          if (!response.ok) throw new Error('Mobile menu heavy request failed with status ' + response.status);
          return response.json();
        })
        .catch(error => {
          window.mobileMenuHeavyDataPromise = null;
          throw error;
        });
    }

    window.mobileMenuHeavyDataPromise
      .then(data => {
        if (!data || data.error) return;
        setState(prev => ({
          ...prev,
          catalog: Array.isArray(data.catalog) ? data.catalog : prev.catalog,
          popLink: Array.isArray(data.popLink) ? data.popLink : prev.popLink,
          popSec: Array.isArray(data.popSec) ? data.popSec : prev.popSec,
        }));
        setHeavyLoaded(true);
      })
      .catch(console.error);
  }, [menuOpened, heavyLoaded]);

  useEffect(() => {
    initEvents();
  }, []);

  /**
   * Подготовка списка популярных ссылок
   */
  useEffect(() => {
    if (activeCatalogSection !== null &&
      activeCatalogSection.hasOwnProperty('parentId')) {
      let pop_block = state.popSec.find(
        item => Number(item.parent_id) === Number(activeCatalogSection.itemId));
      if (pop_block) pop_block.links = state.popLink.filter(
        item => pop_block.link_id.includes(item.rec_id)).sort((a, b) => {
        if (isNaN(a.sort) || isNaN(b.sort) || Number(a.sort) ===
          Number(b.sort)) return 0;
        return Number(a.sort) > Number(b.sort) ? 1 : -1;
      });
      setPopBlock(pop_block);
    } else setPopBlock(null);
  }, [activeCatalogSection]);

  useEffect(() => {
    setShow(clientWidth < 1280);
  }, [clientWidth]);

  // prevent page scroll
  useEffect(() => {
    if (menuOpened) document.body.classList.add('stop-scrolling');
    else document.body.classList.remove('stop-scrolling');
  }, [menuOpened]);

  // drop catalog section state on change menu type
  useEffect(() => {
    setActiveCatalogSection(null);
  }, [activeMenuType]);

  /**
   * Смена заголовка актуального города
   */
  useEffect(() => {
    let title = '', cityId = null, cityData = null;

    stateCities.cities.forEach(city => {
      if (city.checked === true) {
        cityId = Number(city.id);
        cityData = city;
      }
    });

    setCurrentCityId(cityId);

    // Обновление actualCity в state.citySwitch
    if (cityId && stateCities.cities.length > 0) {
      const updatedCity = stateCities.cities.find(city => Number(city.id) === cityId);
      if (updatedCity) {
        setState(prevState => ({
          ...prevState,
          citySwitch: {
            ...prevState.citySwitch,
            actualCity: updatedCity,
          },
        }));
      }
    }

    // сохраняем данные о городах в Storage
    window.sessionStorage.setItem('deliveryCities',
      JSON.stringify(stateCities.cities));
  }, [stateCities]);

  /**
   * TODO
   */
  useEffect(() => {
    eventEmitter.on('setDeliveryCity',
      data => (onSetDeliveryCity(data.city_ref).
      then(response => console.log(response))));

    eventEmitter.on('cityChange', data => {
      let switchCityId = Number(data.city_id);
      let needReload = Boolean(data.need_reload) || false;
      if (needReload && switchCityId === currentCityId) return;
      // console.log(data)
      onExternalSwitch(switchCityId, needReload);
    });
  }, []);


  function onSetDeliveryCity(npCityRef) {
    return new Promise(resolve => {
      npApi.findCity(npCityRef).then(deliveryCity => {
        setStateCities({...stateCities, deliveryCity: deliveryCity});
        return request({action: 'setDeliveryCity', ref: npCityRef});
      }).then(response => {
        resolve(response);
      });
    });
  }

  function onExternalSwitch(switchCityId, reload) {
    let city = stateCities.cities.find(
      cityItem => (Number(cityItem.id) === switchCityId));
    if (typeof city !== 'object') return;
    // console.log(city)
    onSwitch(city, reload);
  }

  async function onSwitch(city, reload = false) {
    let cityId = Number(city.id);

    let response = await request(
      {action: 'cityChange', id: cityId, path: window.location.pathname});

    if (response && response.status) {
      // Очистка города доставки выбранного на странице товара
      window.localStorage.removeItem('delivery_city');

      if (reload) {
        if (response.link && typeof response.link === 'string') {
          window.location.href = response.link;
        } else {
          window.location.href = city.link;
        }
      } else {
        // обновляем state
        let currentCityList = [...stateCities.cities];

        currentCityList.forEach(city => {
          if (city.checked &&
            Number(city.id) !== cityId) {
            city.checked = false;
          } else if (Number(city.id) === cityId) {
            city.checked = true;
          }
        });

        setStateCities({deliveryCity: response.delivery, cities: currentCityList});
      }
    }
  }

  function request(data) {
    let url = `${apiBaseUrl}region/${data.action}`;
    return new Promise(resolve => {
      axiosInstance.post(url, data).
      then(response => (resolve(response.data))).
      catch(reason => (resolve(null)));
    });
  }

  function initEvents() {
    eventEmitter.on('showMobileCatalog', () => {
      showMenuDirection('catalog');
    });
  }

  function closeMenu() {
    setActiveMenuType(null);
    setMenuOpened(false);
    setShowCitySwitch(false);
  }

  /**
   * Finds and returns the parent section from the catalog by a given parent ID.
   *
   * @param {number} parentId - The ID of the parent section to find.
   * @return {Object|null} - The parent section object if found, otherwise null.
   */
  function findParentSection(parentId) {
    for (let item of state.catalog) {
      if (item.hasOwnProperty('itemId') && (item.itemId) > 0 &&
        Number(item.itemId) === Number(activeCatalogSection.parentId)) {
        return item;
        break;
      }
    }
    return null;
  }

  function showMenuDirection(type) {

    // закрываем меню, если нажали на тот же элемент меню, который уже активен
    if (activeMenuType === type && menuOpened) {
      setMenuOpened(false);
      setActiveMenuType(null);
      setShowCitySwitch(false);
      return;
    }

    setShowCitySwitch(false);

    switch (type) {
      case 'menu':
        setMenuOpened(true);
        setActiveMenuType('menu');
        break;
      case 'catalog':
        setMenuOpened(true);
        setActiveMenuType('catalog');
        break;
      case 'connect':
        // open social widget
        initOpenSocialWidget();
        break;
      case 'personal':
        // Check user auth
        if (!state.isAuth) {
          eventEmitter.emit('showAuth');
          setMenuOpened(false);
        }
        else if (state.personal.length) {
          setMenuOpened(true);
          setActiveMenuType('personal')
        }
        break;
      case 'basket':
        // Check basket items
        initOpenBasket();
        break;
    }
  }

  function onShowCitySwitch(event) {
    event.preventDefault();
    setActiveMenuType(null);
    setShowCitySwitch(true);
  }

  function initOpenBasket() {
    if (menuOpened) setMenuOpened(false);
    if (activeMenuType !== null) setActiveMenuType(null);

    eventEmitter.once('basketInited', () => {
      window.sessionStorage.setItem('basketRequested', 'true');
    });
    eventEmitter.emit('openSmallCart');
  }

  function initOpenSocialWidget() {
    setConnectActive(!connectActive);

    // const socialWidget = new SocialWidget()
    let socialNetworksHolder = document.querySelector(
      '.follow-us-social-buttons-holder');
    if (socialNetworksHolder instanceof HTMLElement) {
      socialNetworksHolder.classList.toggle('active');
    }
  }

  function getBlockTitle(linkId) {
    return state.popLink.find(pop_link => linkId == pop_link.rec_id);
  }

  const menuItems = menuTypes.map((item, key) => {
    const isActive = item.type === 'connect'
      ? connectActive
      : activeMenuType === item.type;

    return <li key={key}
               className={'relative z-[1] w-full h-full flex flex-col justify-center items-center p-0 cursor-pointer'}
               onClick={event => showMenuDirection(item.type)}>
      <div className={'relative'}>
        <img src={isActive ? item.activeIcon : item.icon} alt={item.title} title={item.title} width={'23px'}
             height={'23px'}/>
        {
          item.type === 'basket' && basketProductsCount > 0 && (
            <span className={'tap-bar-item-count'}>{basketProductsCount}</span>
          )
        }
      </div>
      <span
        className={`text-[10px] leading-[13px] font-medium relative bottom-[-5px] ${isActive ? 'text-blue-primary' : 'text-grey-90'}`}>
        {state.messages.hasOwnProperty(item.type)
          ? state.messages[item.type]
          : 'Title'}
      </span>
    </li>;
  });

  const menuTitle = activeMenuType !== null &&
  state.messages.hasOwnProperty(activeMenuType) ?
    state.messages[activeMenuType] :
    showCitySwitch && state.citySwitch.hasOwnProperty('messages') &&
    state.citySwitch.messages.hasOwnProperty('CITY_SWITCH_CHOICE_CITY') ?
      state.citySwitch.messages['CITY_SWITCH_CHOICE_CITY'] :
      activeMenuType;

  return ( show &&
    <>
        <MobileMenu opened={menuOpened}
                    onClose={closeMenu}
                    activeMenuType={activeMenuType}
                    title={menuTitle}
                    section={activeCatalogSection}
                    sectionBlockTitle={popBlock &&
                    Number(popBlock.title_link_id) ? getBlockTitle(
                      popBlock.title_link_id) : null}
                    siteSwitch={state.siteSwitch}
                    citySwitch={state.citySwitch}
                    onShowCitySwitch={onShowCitySwitch}>
          {
            activeMenuType === 'catalog' ?
              <MobileCatalog items={state.catalog}
                             popBlock={popBlock}
                             findParentSection={findParentSection}
                             section={activeCatalogSection}
                             setActiveCatalogSection={setActiveCatalogSection}
                             activeSectionId={activeCatalogSection !== null
                               ? Number(activeCatalogSection.itemId)
                               : 0}/> :
              <></>
          }
          {
            activeMenuType === 'menu' ?
              <MobileNav items={state.menu}
                         openCatalog={() => {showMenuDirection('catalog');}}
                         catalogTitle={state.messages.hasOwnProperty('catalog')
                           ? state.messages['catalog-mob']
                           : 'catalog'}/> :
              <></>
          }
          {
            activeMenuType === 'personal' && state.isAuth &&
            state.personal.length ?
              <MobilePersonal items={state.personal}
                              initOpenBasket={initOpenBasket}/> :
              <></>
          }
          {
            showCitySwitch ?
              <MobileCitySwitch {...state.citySwitch}/> :
              <></>
          }
        </MobileMenu>
        <ul
          style={{
            WebkitBackdropFilter: 'blur(14px) saturate(165%) contrast(104%)',
            backdropFilter: 'blur(14px) saturate(165%) contrast(104%)',
            WebkitTransform: 'translateZ(0)',
            transform: 'translateZ(0)',
          }}
          className={`fixed list-none flex items-center justify-around gap-2 z-[1041]
            left-[12px] right-[12px] bottom-[calc(10px+env(safe-area-inset-bottom,0px))]
            w-auto h-[68px] pt-0 pr-[10px] pb-[7px] pl-[10px] overflow-hidden rounded-[24px]
            border border-solid border-[rgba(150,150,150,0.45)]
            bg-[rgba(255,255,255,0.85)]
            before:content-[''] before:absolute before:inset-0 before:z-0
            before:pointer-events-none before:rounded-[inherit]
            before:bg-[radial-gradient(ellipse_at_50%_-35%,rgba(255,255,255,0.58),transparent_58%)]
            after:content-[''] after:absolute after:inset-[1px] after:z-0
            after:pointer-events-none after:rounded-[23px]`}>
          {menuItems}
        </ul>
      </>
  );
}

export default TapBar;